module.exports = __webpack_public_path__ + "img/77.0b1e5dd4.webp";